import { useEffect, useState } from "react";
import MaterialTable, { MTableBody, MTableToolbar } from "material-table";
import {
  Box,
  Grid,
  Button,
  CircularProgress,
  Typography,
  Paper,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import Popup from "../../../../Base/views/Popup";
import { GetDailyWageReportAction, GetDailyWageReportNotProcessedAction } from "../../../../../../store/Finance/Reports/Action";
import {
  GenerateDailyWageReportHelper,
} from "../../../helper/Reports/GetWageReportHelper";
import ConfirmationDialog from "../../../../Base/views/ConfirmationDialog";
import {
  formatPayDatePeriod,
} from "../../../../Base/helper/baseFunctions";
import { AddMenuHeadingAction } from "../../../../../../store/Menu/Action";
import history from "../../../../../../history";
import { toast } from "react-toastify";
import { GetPayrollTileViewAction } from "../../../../../../store/Finance/PayrollManagement/Action";
import { UpdatePayrollApproverStatusHelper } from "../../../helper/PayrollManagement/PayrollManagement";
import CloseIcon from "@mui/icons-material/Close";
import SelectableMultiSelect from "../../../../Base/views/SelectableMultiSelect";
import DailyWageEmployeeWorkingHoursDialog from "../../../helper/DailyWageHelper/DailyWageEmployeeWorkingHoursDialog";

const PSRWageProcessedEmp = ({selectedYear, selectedMonth, currentMonthData, userRole, readOnly, paydate,worklocationData, handleWorkLoacation}) => {
  const dispatch = useDispatch();
  const { isLoading, daily_wage_report_data } = useSelector(
    (state) => state?.FinanceReducer.WageReportsReducer
  );
  const { work_hours_data } = useSelector(
    (state) => state.LeaveReducer?.WeekOffConfigureReducer
  );
  const [openwarningPopup, setWarningOpenPopup] = useState(false);
  const [navigateSection, setNavigateSection] = useState("");
  const [navigateId, setNavigateId] = useState("");
  const [msg, setMsg] = useState("");
  const [anchorE, setAnchorE] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [viewAttendanceDialog, setViewAttendanceDialog] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isLoadingbtn, setIsLoadingbtn] = useState(false);
  const [filters, setFilters] = useState({
          ats_work_location_id: []
      })
  const f_year = String(selectedYear);
  const f_month = parseInt(selectedMonth, 10).toString();
  useEffect(() => {
    const f_month = parseInt(selectedMonth, 10).toString();
    const locationPayload = JSON.stringify((filters?.ats_work_location_id || [])?.map((item) => ({ ats_work_location_id: item?.work_location_id })));
    dispatch(
      GetDailyWageReportAction({ 
        month: f_month, 
        year: String(selectedYear),
        location: (filters?.ats_work_location_id || [])?.length > 0 ? locationPayload : null
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, filters]);
  const handleFilterChange = (event, value) => {
        if (["ats_work_location_id"].includes(event)) {
        if (value) {
            setFilters({ ...filters, [event]: value });
        } else {
            setFilters({ ...filters, [event]: "" });
        }
      }
    }
  const handleSelect = (rows) => {
    setSelectedRows(rows);
  };

  /// need to check whether action are getting triggered in parent or not
  const handleGenerateClicked = () => {
    if (!work_hours_data) {
      setMsg(
        "Work Hour configuration is required for payroll settings. Please configure it now."
      );
      setNavigateSection("General");
      setNavigateId("4");
      setWarningOpenPopup(true);
    } else {
      setAnchorE(null);
      setOpenDialog(true);
    }
  };

  const handleNavigate = (menu, value) => {
    sessionStorage.setItem("selectedMenu", menu);
    dispatch(AddMenuHeadingAction({ heading: menu }));
    history.push({
      pathname: "/settings",
      state: { click_event: value },
    });
  };
  const handleGenerate = () => {
    setIsLoadingbtn(true);
    const f_year = String(selectedYear);
    const f_month = parseInt(selectedMonth, 10).toString();
    const id = selectedRows.map((item) => item.employee_fk);
    GenerateDailyWageReportHelper({
      employee_id: id?.length ? `{${id}}` : null,
      month: f_month,
      year: f_year,
    }).then((res) => {
      if (res?.data?.statuscode === 200) {
        dispatch(GetDailyWageReportAction({ month: f_month, year: f_year }));
        dispatch(GetDailyWageReportNotProcessedAction({ month: f_month, year: f_year }));
        dispatch(GetPayrollTileViewAction({ year: String(selectedYear) }))
        setSelectedRows([]);
      } else if (res?.data?.statuscode === 500) {
          toast.error(res?.data?.error?.[0]?.message)
      } else {
          toast.error("Something went wrong")
      }
      setIsLoadingbtn(false);
    });
    setOpenDialog(false);
  };

   const [updateStatus, setUpdateStatus] = useState("")
   const [openDialog2, setOpenDialog2] = useState(false);
      const handleStatusChange = (status) => {
          setUpdateStatus(status)
          setOpenDialog2(true);
      }
      const handleUpdateApproverStatus = () => {
          UpdatePayrollApproverStatusHelper({
              status: updateStatus,  // Approved/Rejected
              payroll_type: "work-based", // regular / work-based
              month: String(selectedMonth),  
              year: String(selectedYear)
          }).then((res) => {
              dispatch(GetPayrollTileViewAction({ year: String(selectedYear) }))
              setOpenDialog2(false);
          })
      }
  const tableTitle = (
        <Box>
          <Typography variant="h6" fontWeight={600}>
            Processed Employee
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Employees who have been processed for the selected period
          </Typography>
        </Box>
    );

  return (
    <Box sx={{overflowY: "auto" }}>
      <Paper sx={{ my: 1, p: 2, backgroundColor: "#f8fafc", borderRadius: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={6} md={2}>
                <Typography variant="caption" color="text.secondary">Submitted On:</Typography>
                <Typography variant="body2" fontWeight={500}>
                {currentMonthData?.["Work-Based_submittedon"] ? new Date(currentMonthData?.["Work-Based_submittedon"]).toLocaleDateString() : "-"}
                </Typography>
            </Grid>
            <Grid item xs={6} md={2}>
                <Typography variant="caption" color="text.secondary">Submitted By:</Typography>
                <Typography variant="body2" fontWeight={500}>
                  {currentMonthData?.["Work-Based_submitted_by"] ? currentMonthData?.["Work-Based_submitted_by"] : "-"}
                  </Typography>
            </Grid>
            <Grid item xs={6} md={2}>
                <Typography variant="caption" color="text.secondary">Approved On:</Typography>
                <Typography variant="body2" fontWeight={500}>
                    {currentMonthData?.["Work-Based_approvedon"] ? new Date(currentMonthData?.["Work-Based_approvedon"]).toLocaleDateString() : "-"}
                </Typography>
            </Grid>
            <Grid item xs={6} md={2}>
                <Typography variant="caption" color="text.secondary">Approved By:</Typography>
                <Typography variant="body2" fontWeight={500}>
                  {currentMonthData?.["Work-Based_approved_by"] ? currentMonthData?.["Work-Based_approved_by"] : "-"}
                  </Typography>
          </Grid>
          <Grid item xs={12} md={4} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
              <>
              <Box sx={{
                  display: "flex",
                  cursor: "pointer",
                  color: "#0854ffcf",
                  mr: 2,
                  fontSize: "16px",
                  fontWeight: 500,
                  "&:hover": {
                      textDecoration: "underline",
                  }
              }}>
                  <div onClick={() => setViewAttendanceDialog(true)}>
                      View Working Hrs Summary
                  </div>
              </Box>
              {(daily_wage_report_data?.length === 0 ||
                selectedRows?.length > 0) && !readOnly && (
                <Button
                  onClick={handleGenerateClicked}
                  className="mpl-primary-btn"
                  disabled={isLoadingbtn}
                  startIcon={isLoadingbtn ? <CircularProgress size={18} color="inherit" /> : null}
                >
                  {selectedRows?.length > 0
                    ? "Regenerate Payroll"
                    : "Generate Payroll"}
                </Button>
              )}
              {(userRole === "approver" || userRole === "both") && currentMonthData?.["Work-Based_status"] === "Action Needed" && (
                  <>
                  <Button
                      onClick={() => handleStatusChange("Approved")}
                      className="mpl-primary-btn"
                      color="success"
                      sx={{ ml: 1 }}
                  >
                      Approve
                  </Button>
                  <Button
                      onClick={() => handleStatusChange("Rejected")}
                      className="mpl-primary-btn"
                      color="error"
                      sx={{ ml: 1 }}
                  >
                      Reject
                  </Button>
                  </>
              )}
              </>
           </Grid>
        </Grid>
      </Paper>
      <Box>
        <MaterialTable
          isLoading={isLoading}
          columns={[
            {
              title: "Employee No",
              headerStyle: {
                width: "12%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "12%",
                textAlign: "start",
                padding: "10px 0px 5px 5px",
              },
              field: "employee_no",
            },
            {
              title: "Employee Name",
              headerStyle: {
                width: "15%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "15%",
                textAlign: "start",
                padding: "0px 0px 0px 5px",
              },
              field: "employee_name",
            },
            { title: "Work Location", 
               headerStyle: {
                width: "15%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "15%",
                textAlign: "start",
                padding: "0px 0px 0px 7px",
              }, 
              field: "work_location_name",
              render: (rowData) => rowData?.work_location_name || "N/A"            
            },
            {
              title: "DOJ",
              field: "doj",
              align: "center",
              headerStyle: {
                width: "9%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "9%",
                textAlign: "start",
                padding: "0px 0px 0px 5px",
              },
            },
            {
              title: "Days In Month",
              field: "days_in_a_month",
              headerStyle: {
                width: "12%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "12%",
                textAlign: "start",
                padding: "0px 0px 0px 2%",
              },
            },
            {
              title: "Actual Working Hrs",
              field: "actual_working_hours",
              headerStyle: {
                width: "12%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "12%",
                textAlign: "start",
                padding: "0px 0px 0px 2%",
              },
            },
            {
              title: "Total Earnings",
              field: "total_earnings",
              headerStyle: {
                width: "12%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "12%",
                textAlign: "start",
                padding: "0px 0px 0px 1%",
              },
            },
            {
              title: "Total Deductions",
              field: "total_deductions",
              headerStyle: {
                width: "14%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "14%",
                textAlign: "start",
                padding: "0px 0px 0px 1%",
              },
            },
            {
              title: "Net Salary",
              field: "net_salary",
              headerStyle: {
                width: "10%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "10%",
                textAlign: "start",
                padding: "0px 0px 0px 1%",
              },
            },
          ]}
          data={daily_wage_report_data || []}
          options={{
            maxBodyHeight: 320,
            minBodyHeight: 320,
            maxWidth: "80vh",
            rowStyle: { fontSize: "13px" },
            headerStyle: { padding: "5px 0px 5px 0px", fontWeight: "bold" },
            cellStyle: {height: "35px"},
            sorting: true,
            search: true,
            searchFieldAlignment: "right",
            searchAutoFocus: false,
            filtering: false,
            paging: true,
            pageSizeOptions: [25, 50],
            pageSize: 25,
            selection: !readOnly,
            actionsColumnIndex: -1,
            showSelectAllCheckbox: true,
            showTextRowsSelected: true,
            grouping: false,
            columnsButton: false,
            showTitle: true,
          }}
          components={{
            Toolbar: (props) => (
              <Box sx={{ width: "full", display: "flex", flexDirection: { xs: "column", sm: "row" }, flexGrow: 1 }}>
                  <Box
                      sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      backgroundColor: "#f3edfd",
                      padding: "0px 0px 0px 20px",
                      flexGrow: 1,
                      minHeight: "48px !important",
                      }}
                  >
                  <Box>
                      <Typography variant='h6'>
                          {tableTitle}
                      </Typography>
                  </Box>
                  <Box sx={{width: "210px", display: "flex", alignItems: "center", pt: 0.5}}>
                      <SelectableMultiSelect
                          multiple
                          label="Work Location"
                          placeholder="Select Location"
                          value={filters?.ats_work_location_id}
                          loading={handleWorkLoacation}
                          fieldLabel="work_location_name"
                          name="ats_work_location_id"
                          size="small"
                          onChangeEvent={handleFilterChange}
                          data={worklocationData}
                          menuHeight={150} // optional
                      />
                  </Box> 
                  </Box>
                      <Box
                      sx={{
                          "& .MuiToolbar-root": {
                          padding: "14px 16px !important",
                          margin: "0 !important",
                          minHeight: "48px !important",
                          },
                          "& .MuiFormControl-root": {
                          margin: "0 !important",
                          },
                          "& .MuiInputBase-root": {
                          marginLeft: "-20px !important",
                          }
                      }}
                      >
                          <MTableToolbar {...props} />
                      </Box>
                  </Box>
          ),
            Body: (props) =>
              daily_wage_report_data?.length === 0 ? (
                <tbody>
                  <tr>
                    <td colSpan={props.columns.length}>
                      <Box
                        sx={{
                          height: 320,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#888",
                          fontSize: "16px",
                        }}
                      >
                        Pay summary report not generated for this month-year
                        selection.
                      </Box>
                    </td>
                  </tr>
                </tbody>
              ) : (
                <MTableBody {...props} />
              ),
          }}
          onSelectionChange={handleSelect}
          
          title={""}
        />
      </Box>

      <ConfirmationDialog
        title="Generate Payroll"
        content={`Payroll will be generated from ${formatPayDatePeriod(
          paydate
        )}. Are you sure you want to continue?`}
        anchorE={anchorE}
        openDialog={openDialog}
        closeDialog={setOpenDialog}
        OkButtonText="Yes"
        onSubmit={handleGenerate}
      />
      <DailyWageEmployeeWorkingHoursDialog
        content={`Employee Working Hours – ${formatPayDatePeriod(paydate)}.`}
        open={viewAttendanceDialog}
        onClose={() => setViewAttendanceDialog(false)}
        f_year={f_year}
        f_month= {f_month}
      />
      <Popup
        fullWidth={true}
        maxWidth="md"
        title="Warning"
        openPopup={openwarningPopup}
        setOpenPopup={setWarningOpenPopup}
      >
        <Typography sx={{ pt: 2, pb: 2, textAlign: "center" }} variant="h5">
          ⚠️ {msg}
        </Typography>

        <Box display="flex" justifyContent="center" gap={2} sx={{ mt: 2 }}>
          <Button
            onClick={() => handleNavigate(navigateSection, navigateId)}
            className="mpl-primary-btn"
          >
            Configure Now
          </Button>
        </Box>
      </Popup>
      <Dialog open={openDialog2} onClose={() =>setOpenDialog2(false)} maxWidth="xs" fullWidth >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                Confirm Action
                <IconButton onClick={() =>setOpenDialog2(false)} size="small">
                <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Typography>
                {`Are you sure you want to ${updateStatus === "Approved" ? "approve" : updateStatus === "Rejected" ? "reject" : ""}?`}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={handleUpdateApproverStatus} color={updateStatus === "Rejected" ? "error" : "primary"} variant="outlined">
                  {updateStatus === "Approved" ? "Approve" : updateStatus === "Rejected" ? "Reject" : ""}
                </Button>
            </DialogActions>
        </Dialog>
    </Box>
  );
};

export default PSRWageProcessedEmp;